import { BrowserRouter, useRoutes } from "react-router-dom";
import Home from "./pages/Home";
import About from "./pages/About";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Donate from "./pages/Donate";
import Programs from "./pages/Programs";
import Contact from "./pages/Contact";
import Gallery from "./pages/Gallery";

function App() {
  const routes = useRoutes([
    { path: "/", element: <Home /> },
    { path: "/about", element: <About /> },
    { path: "/programs", element: <Programs /> },
    { path: "/donate", element: <Donate /> },
    { path: "/contact", element: <Contact /> },
    { path: "/gallery", element: <Gallery /> },
  ]);

  return routes; // Renders the matched route
}

function Root() {
  return (
    <BrowserRouter>
      <Header />
      <App />
      <Footer />
    </BrowserRouter>
  );
}
export default Root;
